import type { StudentPortfolioActivityResource } from "api/generated";
import { mapAttachment, mapLink, mapVideo } from "shared/mappers";
import { baseTagFromDto } from "./tag.mapper";
import type { StudentActivity } from "portfolio/types";
import { referenceFromDto } from "./reference.mapper";
import { baseSkillFromDto } from "./skill.mapper";
import { studentAssignmentFromDto } from "./assignments.mapper";

export const portfolioActivityFromDto = (
  data: StudentPortfolioActivityResource,
): StudentActivity => ({
  id: data.id,
  taskId: data.task_id,
  educationLevel: data.education_level,
  educationYear: data.education_year,
  title: data.title,
  description: data.description,
  status: data.status,
  datetype: data.datetype,
  date: data?.date ? new Date(data.date) : null,
  startDate: data?.start_date ? new Date(data.start_date) : null,
  endDate: data?.end_date ? new Date(data.end_date) : null,
  isOngoing: data.is_ongoing,
  timeSpent: data.time_spent,
  timeSpentAmount: data.time_spent_amount,
  timeSpentUnit: data.time_spent_unit,
  tagIds: data.tag_ids,
  tags: data.tags.map(baseTagFromDto),
  lobCompetences: data.lob_competences,
  lobCompetenceIds: data.lob_competence_ids,
  attachments: data.attachments.map(mapAttachment),
  links: data.links.map(mapLink),
  videos: data.videos.map(mapVideo),
  reference: data.reference ? referenceFromDto(data.reference) : null,
  star: data.star,
  skillIds: data.skill_ids,
  skills: data.skills.map(baseSkillFromDto),
  isSubActivity: data.is_sub_activity,
  followupActivityId: data.followup_activity_id,
  previousActivityId: data.previous_activity_id,
  relatedActivitiesCount: data.related_activities_count,
  reactionsAmount: data.reactions_amount,
  createdAt: data?.created_at ? new Date(data.created_at) : null,
  meta: {
    canUpdate: data.meta.can_update,
    canDelete: data.meta.can_delete,
    canGrade: Boolean(data.meta.can_grade),
  },
  assignment: data.assignment
    ? studentAssignmentFromDto(data.assignment)
    : null,
});
